import React from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../../components/admin/AdminLayout';

function AdminSitePricingHome() {
  return (
    <AdminLayout title="">
      <h1 style={{ marginTop: 0 }}>Tarifs</h1>
      <p>Gérez les plans et options affichés sur la page tarifs.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px,1fr))', gap: 16, marginTop: 16 }}>
        <div className="card">
          <h3>Plans</h3>
          <p>Offres principales (mensuel, annuel, sur devis...).</p>
          <Link to="/admin/site/tarifs/plans">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Options</h3>
          <p>Modules additionnels et suppléments.</p>
          <Link to="/admin/site/tarifs/options">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Comparatif</h3>
          <p>Tableau “Comparez nos Plans en Détail”.</p>
          <Link to="/admin/site/tarifs/comparatif">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Détails</h3>
          <p>Accordéon “Explorez nos Offres Détaillées”.</p>
          <Link to="/admin/site/tarifs/details">Ouvrir</Link>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminSitePricingHome;
